import { addEventListeners } from './chatbot-event-handlers/chatbot-event-handlers';
/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/

var addChatBotFrame = function addChatBotFrame(_ref) {
  var wfBotViewBean = _ref.wfBotViewBean;
  var customerInfo = wfBotViewBean.customerInfo,
      wfBotEnv = wfBotViewBean.wfBotEnv,
      iframeSrc = wfBotViewBean.iframeSrc,
      samlInfo = wfBotViewBean.samlInfo;
  var bridgeArgs = {
    view: {
      allowDisplay: true,
      allowError: true,
      allowRestore: true,
      allowMinimize: true,
      allowSize: true,
      hasUI: true,
      allowXYPosition: true
    },
    data: {
      src: iframeSrc // disableIframeTimeout: true

    },
    vendorData: {
      customerName: customerInfo ? customerInfo.customerName : '',
      env: wfBotEnv,
      samlInfo: samlInfo
    }
  };

  var initFrameDisplay = function initFrameDisplay(uuid) {
    window.WFUI_BRIDGE.changeSize(uuid, {
      width: '100%',
      height: '100%'
    });
    window.WFUI_BRIDGE.changeDisplay(uuid, 'block');
    window.WFUI_BRIDGE.changeOriginPosition(uuid, {
      top: '50%',
      left: '50%'
    });
    window.WFUI_BRIDGE.changeXYPosition(uuid, {
      x: '-50%',
      y: '-50%'
    });
  };

  var initChildFrame = function initChildFrame(uuid) {
    window.WF_CHATBOT.uuid = uuid;

    if (window.WFUI_BRIDGE && window.WFUI_BRIDGE.changeDisplay) {
      window.WFUI_BRIDGE.changeDisplay(uuid, 'block');
    }

    if (window.WF_CHATBOT && window.WF_CHATBOT.uuid) {
      var _uuid = window.WF_CHATBOT.uuid;
      window.WFUI_BRIDGE.restoreFrame(_uuid);
      initFrameDisplay(_uuid);
    }

    addEventListeners(uuid);
    window.WFUI_BRIDGE.setNonCurrentIframeAriaHidden(true, uuid);
  };

  var errorCallback = function errorCallback() {
    window.WF_CHATBOT.openModal && window.WF_CHATBOT.openModal();
  };

  if (window.WF_CHATBOT && window.WF_CHATBOT.uuid) {
    var uuid = window.WF_CHATBOT.uuid;
    window.WFUI_BRIDGE.restoreFrame(uuid);
    initFrameDisplay(uuid);
    return;
  }

  window.WFUI_BRIDGE.addChildFrame(bridgeArgs, initChildFrame, errorCallback);
};

export default addChatBotFrame;